import { Component, OnInit, ViewChild } from "@angular/core";
import { MedicalAppointmentValidation } from "../../../model/medical-appointment-validation";
import { MedicalOrderEditControlComponent } from "../../controls/medical-order/medical-order-edit/medical-order-edit-control.component";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { BillingMedicalOrder } from "../../../model/billing/billing-order-control";
import { validateMedicalOrderEdit } from "../../../validators/medical-order-edit.validator";
import { BillingOrdenControlWizardService } from "src/app/services/billing/billing-orden-control-wizard.service";
import { WizardStep } from "../../../wizard/wizard.component";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: "app-billing-orden-control-invoice",
  templateUrl: "./billing-orden-control-invoice.component.html",
  styleUrls: ["./billing-orden-control-invoice.component.css"],
})
export class BillingOrdenControlInvoiceComponent
  implements WizardStep
{
  isInit: boolean;


  get valid(): boolean {
     return true;
  }

  get completed(): boolean {
    return true;
  }

  save(): void {}

  async activate() {

  }

}
